import "./roi.css";
import dots from "../../assets/dots.svg";

const metrics = [
  { value: "85%", label: "reduction in repetitive audit and compliance tasks through intelligent automation" },
  { value: "3x", label: "faster response to model drift, bias, and regulatory updates" },
  { value: "90%", label: "improvement in visibility and accountability across AI systems and workflows" },
  { value: "100%", label: "coverage for oversight of third-party models and generative AI deployments" },
  { value: "70%", label: "reduction in compliance fatigue and improved audit-readiness for teams" },
  { value: "95%", label: "accuracy in automated risk classification and policy enforcement across AI models" },
  { value: "80%", label: "faster regulatory compliance reporting with real-time documentation and audit trails" },
  { value: "60%", label: "reduction in operational costs through optimized AI resource management and governance" },
];



const Roi = () => {
  return (
    <section className="grid-card-section">
      <div className="container">
        <div className="grid-card-heading">
          <div className="section-tag">
            <img src={dots} alt="dots" />
            <p>ROI</p>
          </div>
          <h2 className="grid-card-title">Drive Outcomes with Intelligent Governance</h2>
          <p className="grid-card-subtext">
            Reduce manual audit efforts by up to 60%, cut compliance reporting
            time in half, and minimize risk exposure with real-time alerts and
            intelligent remediation
          </p>
        </div>

        <div className="grid-card-metrics">
          {metrics.map((item, index) => (
            <div key={index} className="grid-card-metric">
              <div className="metric-value">{item.value}</div>
              <div className="metric-label">{item.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Roi;
